let aesjs = require('./aes');

let enCodeBinary = function (val) {

  var num = "5^6^5-sin(cos(60))".replace(/(sin|cos)/g, "Math.$1")
  var ua = window.navigator.userAgent

  var key = function () {
    var key = []

    for (var i = 0; i < 32; i++) {
      key[i] = i
      if (i === 10) {
        key[i] = ua.substr(i * 5.4, 1).charCodeAt()
      }

      if (i === 20) {
        key[i] = ua.length
      }

      key[eval(num)] = eval(num)
    }

    var time = new Date()

    key[1] = time.getYear()
    key[2] = time.getMonth()
    key[3] = time.getDate()
    key[4] = time.getDay()

    return key
  }

  var iv = function () {
    var iv = [21, 3, 23, 24, 5, 4, 27, 28, 29, 30, 31, 32, 33, 34, 35, 98]
    return iv
  }

  var strToBinary = function (str) {
    var result = [];
    var list = str.split('');
    for (var i = 0; i < list.length; i++) {
      if (i !== 0) {
        result.push(' ');
      }
      var item = list[i];
      var binaryStr = item.charCodeAt().toString(2);
      result.push(binaryStr);
    }
    return result.join('');
  }

  var textBytes = aesjs.default.utils.utf8.toBytes(val)

  var aesCfb = new aesjs.default.ModeOfOperation.cfb(key(), iv())
  var encryptedBytes = aesCfb.encrypt(textBytes)

  var encryptedHex = aesjs.default.utils.hex.fromBytes(encryptedBytes)

  return strToBinary(encryptedHex)
}

export default enCodeBinary = enCodeBinary;
